/* BB dock: scroll-gated corner button — cart pill shoots left, phone/chat/save/ship/top shoot up.
   Popovers slide out LEFT of their icon, cart-tailored. LIVE. PDP. */
(function(){
  // The DOCK belongs on every page (back-to-top, chat, call, savings, delivery). Only the
  // sticky cart bar needs a product, so it is gated on this flag instead. Bailing out here
  // hid the entire dock everywhere except PDPs.
  var BB_PDP=/\/products\//.test(location.pathname);
  var INK='#EB673C', FICON='#EB673C', SQ='14px'; // FICON = ORANGE icons on black fan boxes (owner 2026-07-26)
  var css=document.createElement('style');
  css.textContent=
    /* cart pill: both desktop & mobile, slides in from the right anchor */
    '#bb-matc{display:flex;position:fixed;bottom:16px;right:86px;z-index:99990;align-items:center;justify-content:center;gap:10px;min-height:56px;box-sizing:border-box;padding:8px 10px 8px 14px;background:#fff;border:1px solid #ececec;border-radius:16px;box-shadow:0 6px 20px rgba(0,0,0,.16);font-family:inherit;transform:translateX(120%);opacity:0;pointer-events:none;transition:transform .3s cubic-bezier(.2,.8,.2,1),opacity .18s ease}'+
    'body.bb-past-atc:not(.bb-cart-off) #bb-matc{transform:translateX(0);opacity:1;pointer-events:auto}'+
    '#bb-matc .bb-price{font-weight:700;font-size:14px;white-space:nowrap;color:#111}'+
    '#bb-matc .bb-x{flex:0 0 auto;width:22px;height:22px;border-radius:50%;background:#f3f3f3;border:0;color:#999;font-size:15px;line-height:1;display:flex;align-items:center;justify-content:center;cursor:pointer;padding:0;margin-right:-2px}'+
    '#bb-matc .bb-add{background:#EB673C;color:#fff;border:0;border-radius:9px;padding:10px 16px;font-weight:700;font-size:14px;line-height:1.2;white-space:nowrap}'+
    '#bb-matc .bb-add[disabled]{background:#d9d9d9;color:#595959;cursor:not-allowed;opacity:1}'+  /* BB_FOB_SOLDOUT */
    '@media(max-width:749px){'+
      '#bb-matc{left:8px;right:76px;bottom:calc(14px + env(safe-area-inset-bottom));min-height:42px;border-radius:13px;padding:6px 8px 6px 12px;gap:7px}'+  /* right:76 clears the 60px FAB toggle; bottom:14 = 8 + (60-48)/2 centers the 48px pill on the 60px toggle (measured) */
      '#bb-matc .bb-add{flex:1;padding:9px 12px}'+
      '#bb-matc .bb-x{width:20px;height:20px;font-size:14px}'+
      'body{padding-bottom:70px}'+
    '}'+
    /* FAB stack — hidden until scrolled past the real ATC */
    '#bb-fab{position:fixed;right:16px;bottom:16px;z-index:99992;display:flex;flex-direction:column;align-items:center;gap:10px}'+
    '@media(max-width:749px){#bb-fab{right:8px;bottom:calc(8px + env(safe-area-inset-bottom));gap:9px}#bb-fab-toggle{width:60px!important;height:60px!important}#bb-fab-toggle svg{width:30px;height:30px}#bb-fab .bb-fab-item{width:46px!important;height:46px!important}}'+
    '#bb-fab .bb-fab-item{width:46px;height:46px;border-radius:'+SQ+'!important;display:flex;align-items:center;justify-content:center;background:#fff;border:1px solid #e4e4e4;box-shadow:0 3px 12px rgba(0,0,0,.16);transition:opacity .2s ease,transform .2s ease;cursor:pointer;text-decoration:none;padding:0}'+
    'body:not(.bb-dock) #bb-fab .bb-fab-item{opacity:0;transform:translateY(18px) scale(.8);pointer-events:none}'+
    '#bb-fab-toggle{width:56px;height:56px;border-radius:16px!important;background:#111;border:0;box-shadow:0 4px 14px rgba(0,0,0,.3);display:flex;align-items:center;justify-content:center;cursor:pointer;padding:0}'+
    '#bb-fab-toggle svg{transition:transform .2s ease}'+
    /* popover — positioned by JS to the LEFT of its icon, centered */
    '#bb-fab-pop{position:fixed;z-index:99993;width:250px;max-width:74vw;background:#fff;border:1px solid #e4e4e4;border-radius:14px;box-shadow:0 8px 28px rgba(0,0,0,.24);padding:14px 16px;font-family:inherit;font-size:12.5px;line-height:1.5;color:#333;opacity:0;transform:translateX(14px);pointer-events:none;transition:opacity .2s ease,transform .2s ease}'+
    '#bb-fab-pop.bb-show{opacity:1;transform:translateX(0);pointer-events:auto}'+
    '#bb-fab-pop h4{margin:0 0 7px;font-size:13.5px;font-weight:800;color:#111;letter-spacing:.2px}'+
    '#bb-fab-pop b{color:#111}'+
    '#bb-fab-pop .bb-pop-close{position:absolute;top:5px;right:9px;border:0;background:none;font-size:17px;color:#aaa;cursor:pointer;line-height:1}'+
    '#bb-fab-pop .cart{color:#888;font-size:11.5px;margin-bottom:8px}'+
    '#bb-fab-pop .row{display:flex;justify-content:space-between;align-items:center;gap:10px;padding:8px 0;border-top:1px solid #f0f0f0}'+
    '#bb-fab-pop .row .sub{font-size:11px;color:#9a9a9a;font-weight:400;margin-top:1px}'+
    '#bb-fab-pop .amt{font-weight:800;color:#111;white-space:nowrap;font-size:13px}'+
    '#bb-fab-pop .total{margin-top:11px;background:#fbeee8;color:#EB673C;font-weight:800;text-align:center;padding:9px;border-radius:9px;font-size:12.5px}'+
    /* active savings tab: orange OUTLINE, not solid (so it does not compete with Add to Cart) */
    '#bb-buytabs .bb-acc-tab{border:1px solid #f0b49f !important;white-space:nowrap !important}'+
    /* children (esp. the ▾ arrow span) must not be the click target — the theme tab handler checks e.target=[data-t] button; taps on the arrow were dead. pointer-events:none routes every tap to the button. */
    '#bb-buytabs .bb-acc-tab *{pointer-events:none !important}'+
    '@media(max-width:749px){#bb-buytabs .bb-acc-tab{font-size:11px !important;padding-left:6px !important;padding-right:6px !important;min-width:0 !important}}'+
    '#bb-buytabs button[style*="rgb(235, 103, 60)"]{background:#fff !important;color:#EB673C !important;border-color:#EB673C !important}'+
    /* kill theme native back-to-top */
    '#BackToTop,[class*=back-to-top],[class*=scroll-to-top],[class*=scrolltotop]{display:none!important}';
  document.head.appendChild(css);

  var SOLD_RE = new RegExp("sold\\s*out|unavailable|not available", 'i');  /* BB_FOB_SOLDOUT */
  function realAtc(){return document.querySelector('product-form button[name=add],button[name=add],.product-form__submit,form[action*="/cart/add"] [type=submit]');}
  function pickPrice(el){
    if(!el)return '';
    var m=(el.textContent||'').match(/(?:CA)?\$\s?[\d,]+(?:\.\d{2})?/);   // allow "$ 49.99" (CA space format)
    if(!m)return '';
    var v=m[0].replace(/^CA/,'').replace(/\$\s+/,'$');                    // normalize "$ 49.99" -> "$49.99"
    return (v==='$0.00'||v==='$0')?'':v;                                  // ignore the calculator's $0.00
  }
  function priceText(){
    var sels=['.price__current .money','.price-item--regular','.price__sale .money','[data-product-price]','.price .money','.price__regular','.product__price','.price','[class*=price] .money'];
    for(var i=0;i<sels.length;i++){var v=pickPrice(document.querySelector(sels[i]));if(v)return v;}
    var atc=realAtc();
    if(atc){var box=atc.closest('form')||atc.closest('[class*=product]')||atc.parentElement;var v2=pickPrice(box);if(v2)return v2;}
    return '';
  }
  function money(c){return '$'+(c/100).toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2});}
  // FREIGHT REBUILD 2026-07-30 — was a hard-coded FLAT ladder (149/249/349/449) that ignored
  // both delivery zone and crane mode, so it quoted $149 to a Texas crane cart that pays $274 at
  // checkout. Now reads the same per-zone tables the estimator publishes; returns null when the
  // zone isn't known yet, and the caller shows the honest range instead of a wrong number.
  function bbLadder(){
    try{
      var st=sessionStorage.getItem('bb_geo_state'); if(!st) return null;
      var z=(window.BB_ZONES||{})[st]; if(!z) return null;
      /* ⭐⭐ ONE LANE SOURCE. This resolved from __bbCartCrane (the older cart flag) and DEFAULTED
         TO LIGHT when the lane was unknown, so a crane-only cart was quoted $149 in this panel
         while the date one row below correctly read the Heavy window (measured live 2026-10-17,
         CA, $371.88 crane-only cart). Under-quoting is the unsafe direction: checkout bills $199.
         bbLaneKnown() resolves __bbCartLanesTruth first — the same authority the estimator, the
         banner and the delivery card use — and keeps every older branch beneath it.
         ⛔ `=== true` is DELIBERATE: bbLaneKnown() returns NULL for a mixed cart, and the mixed
            branch just below owns that case by returning the SUMMED ladder. Coercing null to
            false here would quote a mixed cart at the Light rate. */
      var crane=(typeof bbLaneKnown==='function')
        ? (bbLaneKnown()===true)
        : ((window.__bbCartCraneKnown&&window.__bbCartItemCount>0)?!!window.__bbCartCrane:false);
      // MIXED CART: both delivery profiles are charged, so the bar must quote the SUM or it
      // undercuts the panel directly above it and the checkout below it. Same single source the
      // header banner reads (the estimator's bbMixedRates) — never a second implementation, so a
      // reprice can never move one surface and not another. Falls back to the binary read when the
      // estimator has not loaded yet or the cart is single-lane.
      var _lanes=window.__bbCartLanes;
      if(_lanes&&_lanes.loose&&_lanes.crane&&typeof window.BB_MIXED_RATES_FN==='function'){
        try{ var _mx=window.BB_MIXED_RATES_FN(); var _ml=_mx&&_mx[z]; if(_ml&&_ml.length) return _ml; }catch(e){}
      }
      var tbl=crane?window.BB_CRANE_RATES:window.BB_SHIP_RATES;
      var lad=tbl&&tbl[z];
      return (lad&&lad.length)?lad:null;
    }catch(e){ return null; }
  }
  function freightFor(cents){
    // ⛔ NO HARDCODED FLOOR. The ladder's band 0 carries this zone's real minimum
    //    ($250/$500/$750/$1000), so the pick loop below returns null under it by itself.
    var lad=bbLadder(); if(!lad) return null;
    var pick=null;
    for(var i=0;i<lad.length;i++) if(cents>=lad[i].min) pick=lad[i];
    return pick?Math.round(pick.rate/100):null;
  }
  // Full span across every zone and both lanes, derived from whatever the estimator published —
  // never a hard-coded range that silently goes stale after a rate change.
  /* The lane, resolved the way the BANNER resolves it: cart truth first, then the viewed
     variant (__bbLaneCrane / __bbNeedsCrane, both derived from custom.shipping_mode).
     Returns null when genuinely unknown so the caller can widen instead of guessing LOOSE -
     guessing loose on a crane PDP under-quotes checkout. */
  function bbLaneKnown(){
    try{
      /* ⭐⭐ CART TRUTH FIRST — the same authority the estimator, the banner and the delivery card
         now use (custom.shipping_mode, refreshed on every cart re-render). This used to prefer
         __bbCartCrane, a SECOND older cart flag, and then the VIEWED PDP VARIANT, so the mobile
         bar could quote a different lane from the card directly above it.
         ⛔ A MIXED cart returns null ON PURPOSE: this function's contract is "null means widen",
            and the caller spans light-low -> heavy-high. Answering true or false for a mixed cart
            would quote one truck and silently hide the other. */
      var _bbT=window.__bbCartLanesTruth;
      if(_bbT&&(_bbT.crane||_bbT.loose)){ if(_bbT.crane&&_bbT.loose) return null; return !!_bbT.crane; }
      if(window.__bbCartCraneKnown && window.__bbCartItemCount>0) return !!window.__bbCartCrane;
      /* PDP: decide from the VIEWED VARIANT, the same attribute the banner uses. The globals lag a
         variant change (bb:ship-rate fires 0x on a PDP), so the attribute wins over them. */
      var _el=document.getElementById('bb-ship-est-product');
      var _ids=_el&&_el.getAttribute('data-bb-crane-ids');
      var _f=document.querySelector('form[action*="/cart/add"] [name="id"]');
      if(_ids!==null&&_ids!==undefined&&_f&&_f.value) return (' '+_ids+' ').indexOf(' '+_f.value+' ')!==-1;
      if(typeof window.__bbLaneCrane==='boolean') return window.__bbLaneCrane;
      if(window.__bbNeedsCrane===true) return true;
      /* no product context -> UNKNOWN, so the caller shows the zone's loose-crane span rather
         than silently quoting loose. */
      return null;
    }catch(e){ return null; }
  }
  /* The visitor zone's PAID rate for one lane. First NON-ZERO band on purpose: band 0 reads $0
     once the free tier applies, and "$0" on an empty cart promises free delivery to someone who
     has not qualified for it. */
  function bbZonePaid(crane){
    try{
      var st=sessionStorage.getItem('bb_geo_state'); if(!st) return null;
      var z=(window.BB_ZONES||{})[st]; if(z==null) return null;
      var tbl=crane?window.BB_CRANE_RATES:window.BB_SHIP_RATES;
      var lad=tbl&&tbl[z]; if(!lad||!lad.length) return null;
      for(var i=0;i<lad.length;i++){ var d=Math.round(lad[i].rate/100); if(d>0) return d; }
      return null;
    }catch(e){ return null; }
  }
  /* Zone-true headline for an empty/under-minimum cart: exact when the lane is known, else that
     zone's loose-crane span. Never the global all-zone range, which is what showed "$0-$399". */
  function bbZoneHeadline(){
    var lane=bbLaneKnown();
    if(lane!==null){ var r=bbZonePaid(lane); if(r!==null) return '$'+r; }
    var lo=bbZonePaid(false), hi=bbZonePaid(true);
    if(lo!==null&&hi!==null) return (lo===hi)?('$'+lo):('$'+lo+'&ndash;$'+hi);
    if(hi!==null) return '$'+hi;
    if(lo!==null) return '$'+lo;
    return null;
  }
  function bbFreightRange(){
    var lo=null,hi=null;
    try{
      [window.BB_SHIP_RATES,window.BB_CRANE_RATES].forEach(function(tbl){
        if(!tbl) return;
        Object.keys(tbl).forEach(function(z){
          (tbl[z]||[]).forEach(function(t){
            var d=Math.round(t.rate/100);
            if(lo===null||d<lo) lo=d; if(hi===null||d>hi) hi=d;
          });
        });
      });
    }catch(e){}
    return (lo!==null&&hi!==null&&lo!==hi)?('$'+lo+'&ndash;$'+hi):null;
  }
  function getCart(){return fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).catch(function(){return null;});}
  /* ⛔ CADENCE IS MEASURED, NOT ASSERTED. Naming the area turns a vague claim into a checkable one,
     so the frequency has to hold. Over 52 weeks of paid orders "every week" is true in CA/WA/CO/OR
     and BC only; Maine is 3 weeks a year. Codes: w=every week, m=most weeks, r=regularly,
     s=scheduled runs, x=NOT SERVED (no delivery promise may render at all).
     Rebuild with shopify-tools/_delivery_cadence_by_state.mjs; do not hand-edit. */
  var BB_AREA={AB:['Alberta','m'],AK:['Alaska','x'],AL:['Alabama','x'],AR:['Arkansas','x'],AZ:['Arizona','m'],BC:['British Columbia','w'],CA:['California','w'],CO:['Colorado','w'],CT:['Connecticut','s'],DE:['Delaware','s'],FL:['Florida','r'],GA:['Georgia','r'],HI:['Hawaii','x'],IA:['Iowa','r'],ID:['Idaho','m'],IL:['Illinois','r'],IN:['Indiana','s'],KS:['Kansas','s'],KY:['Kentucky','s'],LA:['Louisiana','s'],MA:['Massachusetts','r'],MB:['Manitoba','r'],MD:['Maryland','r'],ME:['Maine','s'],MI:['Michigan','r'],MN:['Minnesota','r'],MO:['Missouri','s'],MS:['Mississippi','s'],MT:['Montana','r'],NB:['New Brunswick','s'],NC:['North Carolina','r'],NE:['Nebraska','s'],NH:['New Hampshire','s'],NJ:['New Jersey','s'],NL:['Newfoundland and Labrador','x'],NM:['New Mexico','r'],NS:['Nova Scotia','s'],NT:['Northwest Territories','x'],NU:['Nunavut','x'],NV:['Nevada','m'],NY:['New York','m'],OH:['Ohio','r'],OK:['Oklahoma','s'],ON:['Ontario','m'],OR:['Oregon','w'],PA:['Pennsylvania','r'],PE:['Prince Edward Island','s'],QC:['Quebec','s'],RI:['Rhode Island','s'],SC:['South Carolina','s'],SD:['South Dakota','s'],SK:['Saskatchewan','r'],TN:['Tennessee','r'],TX:['Texas','m'],UT:['Utah','m'],VA:['Virginia','r'],VT:['Vermont','s'],WA:['Washington','w'],WI:['Wisconsin','r'],WY:['Wyoming','r'],YT:['Yukon','x']};
  function neighborLine(){
    var els=document.querySelectorAll('span,div,p,strong,b');
    for(var i=0;i<els.length && i<3000;i++){var tx=els[i].textContent||'';if(tx.length<70 && /Neighbor/i.test(tx)){var m=tx.match(/(\d+)\s*Neighbor/i);if(m)return 'We’ve delivered to <b>'+m[1]+' neighbors</b> near you.';}}
    try{
      var st=sessionStorage.getItem('bb_geo_state');
      var a=st&&BB_AREA[st];
      if(a){
        if(a[1]==='x') return '';
        var nm='<b>'+a[0]+'</b>';
        if(a[1]==='w') return 'We deliver to homes across '+nm+' every week.';
        if(a[1]==='m') return 'We deliver to homes across '+nm+' most weeks.';
        if(a[1]==='r') return 'We deliver to homes across '+nm+' regularly.';
        return 'We run scheduled deliveries across '+nm+'.';
      }
    }catch(e){}
    return 'Delivered and unloaded on your property.';
  }

  /* ---- dock hide/show (for chat) + Tidio ---- */
  var chatOpen=false;
  function dockEls(){return [document.getElementById('bb-fab'),document.getElementById('bb-matc'),document.getElementById('bb-fab-pop')];}
  function showDock(){dockEls().forEach(function(e){if(e)e.style.display='';});}
  function hideDock(){dockEls().forEach(function(e){if(e)e.style.display='none';});}
  function tapi(){return window.tidioChatApi;}
  function hideTidio(){var a=tapi();if(a&&a.hide&&!chatOpen){try{a.hide();}catch(e){}}}
  function openChat(){var a=tapi();if(a){chatOpen=true;hideDock();try{a.show();a.open();}catch(e){}}else{location.href='mailto:orders@barrierbossusa.com';}}
  document.addEventListener('tidioChat-ready',function(){hideTidio();var a=tapi();if(a&&a.on){a.on('open',function(){chatOpen=true;hideDock();});a.on('close',function(){chatOpen=false;setTimeout(function(){hideTidio();showDock();},200);});}});
  setInterval(function(){hideTidio();},1000);

  var PHONE='<svg viewBox="0 0 24 24" width="23" height="23" fill="'+FICON+'"><path d="M6.6 10.8c1.4 2.8 3.8 5.1 6.6 6.6l2.2-2.2c.3-.3.7-.4 1-.2 1.1.4 2.3.6 3.6.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1C10.6 21 3 13.4 3 4c0-.6.4-1 1-1h3.5c.6 0 1 .4 1 1 0 1.2.2 2.4.6 3.6.1.4 0 .8-.2 1l-2.3 2.2z"/></svg>';
  var CHAT='<svg viewBox="0 0 24 24" width="23" height="23" fill="'+FICON+'"><path d="M4 4h16a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H9l-4 4V5a1 1 0 0 1 1-1z"/></svg>';
  var UP='<svg viewBox="0 0 24 24" width="23" height="23" fill="'+FICON+'"><path d="M12 5l7 7h-4v7h-6v-7H5z"/></svg>';
  var SAVE='<svg viewBox="0 0 24 24" width="22" height="22" fill="'+FICON+'"><path d="M12.4 2H20a2 2 0 0 1 2 2v7.6a2 2 0 0 1-.59 1.42l-8 8a2 2 0 0 1-2.83 0l-6.6-6.6a2 2 0 0 1 0-2.83l8-8A2 2 0 0 1 12.4 2zM17 6.2a1.4 1.4 0 1 0 0 2.8 1.4 1.4 0 0 0 0-2.8z"/></svg>';
  var SHIP='<svg viewBox="0 0 24 24" width="23" height="23" fill="'+FICON+'"><path d="M3 5h10a1 1 0 0 1 1 1v8H2V6a1 1 0 0 1 1-1zm12 3h3.3a1 1 0 0 1 .8.4l2 2.7a1 1 0 0 1 .2.6V14h-8V8z"/><circle cx="7" cy="18.5" r="1.9"/><circle cx="18" cy="18.5" r="1.9"/></svg>';
  var BUBBLE='<svg viewBox="0 0 24 24" width="26" height="26" fill="#fff"><path d="M4 4h16a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H9l-4 4V5a1 1 0 0 1 1-1z"/><circle cx="9" cy="10" r="1.2" fill="'+INK+'"/><circle cx="12" cy="10" r="1.2" fill="'+INK+'"/><circle cx="15" cy="10" r="1.2" fill="'+INK+'"/></svg>';
  var CLOSE='<svg viewBox="0 0 24 24" width="22" height="22"><path d="M6 6l12 12M18 6L6 18" stroke="#fff" stroke-width="2.6" stroke-linecap="round" fill="none"/></svg>';

  function setOpen(open){document.body.classList.toggle('bb-dock',open);document.body.classList.toggle('bb-cart-off',!open);var t=document.getElementById('bb-fab-toggle');if(t)t.innerHTML=open?CLOSE:BUBBLE;if(!open){var p=document.getElementById('bb-fab-pop');if(p)p.classList.remove('bb-show');}}

  function popover(html,anchor){
    var p=document.getElementById('bb-fab-pop');
    if(!p){p=document.createElement('div');p.id='bb-fab-pop';document.body.appendChild(p);stopBubble(p);}
    p.classList.remove('bb-show');
    p.innerHTML='<button class="bb-pop-close" type="button" aria-label="Close">&times;</button>'+html;
    if(anchor){
      var r=anchor.getBoundingClientRect();
      p.style.right=(window.innerWidth-r.left+12)+'px';p.style.left='auto';
      p.style.top='-9999px';                    // measure off-screen
      var ph=p.offsetHeight;
      var top=Math.max(10,Math.min(r.top+r.height/2-ph/2, window.innerHeight-ph-10));
      p.style.top=top+'px';
    }
    requestAnimationFrame(function(){p.classList.add('bb-show');});
    p.querySelector('.bb-pop-close').onclick=function(){p.classList.remove('bb-show');};
  }

  function showSavings(anchor){getCart().then(function(c){
    var sub=c?c.total_price:0, b;
    if(sub>0){
      var ach=Math.round(sub*0.05);
      var bb=Math.min(Math.round(sub*0.05),50000); // 5% back, capped at $500
      b='<div class="cart">Your cart: <b>'+money(sub)+'</b></div>'+
        '<div class="row"><div><b>Bank transfer</b><div class="sub">5% off at checkout</div></div><span class="amt">'+money(ach)+'</span></div>'+
        '<div class="row"><div><b>BarrierBucks</b><div class="sub">5% back, automatic</div></div><span class="amt">'+money(bb)+'</span></div>'+
        '<div class="total">Up to '+money(ach+bb)+' back on this order</div>';
    } else {
      b='<div class="row"><div><b>Bank transfer</b><div class="sub">at checkout</div></div><span class="amt">5% off</span></div>'+
        '<div class="row"><div><b>BarrierBucks</b><div class="sub">automatic</div></div><span class="amt">5% back</span></div>'+
        '<div class="total">Up to 15% back on every order</div>';
    }
    popover('<h4>💰 Ways to save</h4>'+b, anchor);
  });}
  function etaRow(){
    var e=(window.BB_ETA&&window.BB_ETA.etaStr)?window.BB_ETA.etaStr:'';
    if(!e){
      /* ⛔ WAS 42/56 CALENDAR days, zone-blind and holiday-blind — the last stale date literal in
         the theme. 30/40 BUSINESS days is the SAME promise (42 ÷ 7 × 5 = 30), now counted the way
         the estimator, the banner and the PDP accordion count, so the four can never disagree.
         The zone ladder wins when the estimator has published it; the static is the floor. */
      var m=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
      var _hol=window.BB_HOL||{};
      function _bd(n){var d=new Date(),i=0,g=0;
        while(i<n&&g<4000){g++;d.setDate(d.getDate()+1);var w=d.getDay();
          if(w===0||w===6)continue;
          if(_hol[d.getFullYear()+'-'+('0'+(d.getMonth()+1)).slice(-2)+'-'+('0'+d.getDate()).slice(-2)])continue;
          i++;}
        return d;}
      var _lo=30,_hi=40;
      try{
        var _st=sessionStorage.getItem('bb_geo_state');
        var _z=_st?(window.BB_ZONES||{})[_st]:null;
        if(_z){
          var _cr=(typeof bbLaneKnown==='function')?bbLaneKnown():null;
          /* ⛔ lane UNKNOWN (null) must not default to Light — that under-promises on a crane
             order. Span light-low to heavy-high instead, the mixed-cart rule. */
          var _L=(window.BB_ZONE_QS_ETA||{})[_z],_H=(window.BB_ZONE_ETA||{})[_z];
          if(_cr===true&&_H){_lo=_H[0];_hi=_H[1];}
          else if(_cr===false&&_L){_lo=_L[0];_hi=_L[1];}
          else if(_L&&_H){_lo=_L[0];_hi=_H[1];}
        }
      }catch(_e){}
      var d1=_bd(_lo),d2=_bd(_hi);
      e=(d1.getMonth()===d2.getMonth())?m[d1.getMonth()]+' '+d1.getDate()+'–'+d2.getDate():m[d1.getMonth()]+' '+d1.getDate()+' – '+m[d2.getMonth()]+' '+d2.getDate();
    }
    return '<div class="row"><div><b>Estimated delivery</b><div class="sub">on our own trucks</div></div><span class="amt" style="color:#c4551f">'+e+'</span></div>';
  }
  function showShipping(anchor){getCart().then(function(c){
    // ⭐ PER-ZONE order minimum, read from the ladder the estimator publishes — never a
    //    second floor table here. null = zone not known yet, and then NO figure is shown.
    var sub=c?c.total_price:0, f=freightFor(sub), _mlad=bbLadder(),
        MIN=(_mlad&&_mlad.length&&_mlad[0].min)?_mlad[0].min:null;
    var _rng=bbFreightRange();
    /* ⭐ THE FREE TIER IS LIVE AGAIN — measured 2026-10-27: all 16 zone-lanes on both stores carry
       a $0 band at $5,000. (The comment here previously said it was RETIRED and told the reader
       not to reinstate it; that was true on 2026-10-17 and is now false. A comment that
       contradicts the live data is how a working feature gets "fixed" back out.)
       ⭐ NOTHING NEEDS A CONSTANT: the "FREE" row below is gated on the LADDER returning 0, so it
       follows the profiles by itself. Do not add a free-threshold literal here — that is exactly
       what went stale last time. */
    // f===0 is a FREE order. The old test was (sub>0&&f), and 0 is falsy, so qualifying carts
    // silently fell through and never showed the offer. Test for null instead.
    var feeRow;
    if(sub>0&&f===0){
      feeRow='<div class="row"><div><b>Delivery</b><div class="sub">included</div></div><span class="amt" style="color:#2e7d32;font-weight:800">FREE</span></div>';
    } else if(sub>0&&f!==null){
      var _nudge='<div class="sub">delivered &amp; unloaded</div>'
      feeRow='<div class="row"><div><b>Delivery</b>'+_nudge+'</div><span class="amt">$'+f+'</span></div>';
    } else {
      feeRow='<div class="row"><div><b>Delivery</b><div class="sub">delivered &amp; unloaded</div></div><span class="amt">'+(bbZoneHeadline()||_rng||'shown at checkout')+'</span></div>';
    }
    // Order minimum — only when it applies AND we know this zone's real floor.
    // ⛔ It is PER ZONE now. The literal "$500" that used to sit here told a Northeast
    //    shopper a floor checkout would not honour, so an unknown zone shows NO row.
    var minRow=(sub>0&&MIN!==null&&sub<MIN)
      ? '<div class="row"><div><b>Order minimum</b><div class="sub">add '+money(MIN-sub)+' to check out</div></div><span class="amt">$'+Math.round(MIN/100).toLocaleString('en-US')+'</span></div>'
      : '';
    var b=(sub>0?'<div class="cart">Your cart: <b>'+money(sub)+'</b></div>':'')+
      feeRow+minRow+etaRow()+
      '<div class="row"><div><b>Unloaded on your property</b><div class="sub">fully insured, no surcharges</div></div><span class="amt">included</span></div>'+
      (function(){var _n=neighborLine();return _n?'<div class="total">'+_n+'</div>':'';})();
    /* ⛔⛔ PAUSED REGION: no rate, no date. This panel reads BB_SHIP_RATES correctly, so it
       happily printed "$149" and an arrival window for a region checkout refuses outright. */
    try{
      var _fg=window.BBGeo&&window.BBGeo.get&&window.BBGeo.get(), _fs=_fg&&(_fg.state||_fg.region);
      var _fp=_fs&&(((window.BB_PAUSED_STATES||{})[_fs])||((window.BB_PAUSED_PROVINCES||{})[_fs]));
      if(_fp){
        var _fr=(window.BB_RESUME_INFO||{})[_fs]||[null,null];
        b=(sub>0?'<div class="cart">Your cart: <b>'+money(sub)+'</b></div>':'')
          +'<div class="row"><div><b style="color:#bf360c">New orders paused</b>'
          +'<div class="sub">we can’t keep up with demand</div></div></div>'
          +(_fr[0]?('<div class="row"><div><b>Service resumes</b><div class="sub">'
            +(_fr[1]?('when our '+_fr[1]+' hub opens'):'as soon as we have capacity')
            +'</div></div><span class="amt">'+_fr[0]+'</span></div>'):'')
          +'<div class="row"><div><b>Existing orders</b><div class="sub">unaffected, shipping as scheduled</div></div><span class="amt">on track</span></div>';
      }
    }catch(_fe){}
    popover('<h4>🚚 Delivery &amp; unloading</h4>'+b, anchor);
  });}

  // keep dock taps from bubbling to the theme's document-level "tap outside the drawer = close" cart listener (covers click + touch + pointer, not just click)
  function stopBubble(el){['click','pointerdown','mousedown','touchstart'].forEach(function(t){el.addEventListener(t,function(e){e.stopPropagation();},{passive:true});});}
  /* BB_FOB_SOLDOUT (2026-08-16) — the pill mirrors the real ATC.
     Truth order matches sections/product-template.liquid: data-bb-avail ('0' = sold out),
     then the disabled attribute, then the label. Re-checked on the existing 600ms tick so a
     variant switch flips it both ways. */
  function atcSold(){
    var a=realAtc(); if(!a) return false;
    if(a.dataset&&a.dataset.bbAvail!==undefined&&a.dataset.bbAvail!=='') return a.dataset.bbAvail==='0';
    if(a.disabled) return true;
    return SOLD_RE.test(a.textContent||"");
  }
  function syncAdd(bar){
    var b=bar.querySelector('.bb-add'); if(!b) return;
    var sold=atcSold(), label=sold?'Sold Out':'Add to Cart';
    if(b.textContent!==label) b.textContent=label;
    if(sold){ if(!b.disabled){ b.disabled=true; b.setAttribute('disabled','disabled'); } }
    else if(b.disabled){ b.disabled=false; b.removeAttribute('disabled'); }
  }
  function buildBar(){
    if(document.getElementById('bb-matc'))return;
    var bar=document.createElement('div');bar.id='bb-matc';
    bar.innerHTML='<button class="bb-x" type="button" aria-label="Hide cart bar">&times;</button><span class="bb-price">'+priceText()+'</span><button class="bb-add" type="button">Add to Cart</button>';
    document.body.appendChild(bar);
    stopBubble(bar);
    bar.querySelector('.bb-add').addEventListener('click',function(){var a=realAtc();if(a)a.click();});
    bar.querySelector('.bb-x').addEventListener('click',function(){document.body.classList.add('bb-cart-off');}); // second close: user dismisses the pill; re-arms on next scroll past the ATC
    syncAdd(bar);
    setInterval(function(){var el=bar.querySelector('.bb-price');if(el){var p=priceText();if(p&&el.textContent!==p)el.textContent=p;}syncAdd(bar);},600);
  }
  function buildFab(){
    if(document.getElementById('bb-fab'))return;
    var fab=document.createElement('div');fab.id='bb-fab';
    fab.innerHTML=
      '<button class="bb-fab-item" id="bb-fab-save" type="button" aria-label="Your savings">'+SAVE+'</button>'+
      '<button class="bb-fab-item" id="bb-fab-ship" type="button" aria-label="Your delivery">'+SHIP+'</button>'+
      '<a class="bb-fab-item" id="bb-fab-call" href="tel:+18883062677" aria-label="Call BarrierBoss">'+PHONE+'</a>'+
      '<button class="bb-fab-item" id="bb-fab-chat" type="button" aria-label="Chat with us">'+CHAT+'</button>'+
      '<button class="bb-fab-item" id="bb-fab-top" type="button" aria-label="Back to top">'+UP+'</button>'+
      '<button id="bb-fab-toggle" type="button" aria-label="Contact & tools">'+BUBBLE+'</button>';
    document.body.appendChild(fab);
    stopBubble(fab);
    fab.querySelector('#bb-fab-toggle').addEventListener('click',function(){setOpen(!document.body.classList.contains('bb-dock'));});
    fab.querySelector('#bb-fab-save').addEventListener('click',function(){showSavings(this);});
    fab.querySelector('#bb-fab-ship').addEventListener('click',function(){showShipping(this);});
    fab.querySelector('#bb-fab-chat').addEventListener('click',function(){openChat();});
    fab.querySelector('#bb-fab-top').addEventListener('click',function(){window.scrollTo({top:0,behavior:'smooth'});});
    setOpen(false); // COLLAPSED by default — one bubble; discover the icons on tap
  }
  function nukeNativeTop(){var b=document.getElementById('BackToTop');if(b)b.remove();document.querySelectorAll('[class*=back-to-top],[class*=scroll-to-top]').forEach(function(e){if(!e.closest('#bb-fab'))e.remove();});}
  var scrollGateDone=false;
  function setupScrollGate(){
    if(scrollGateDone) return;
    var atc=realAtc();
    if(!atc) return;
    scrollGateDone=true;
    var wasPast=false;
    function check(){ // pill follows the ATC; FAB is always visible
      var past=atc.getBoundingClientRect().bottom<=12;
      if(past&&!wasPast)document.body.classList.remove('bb-cart-off'); // re-arm: crossing DOWN past the ATC re-shows the cart pill even after a close
      wasPast=past;
      document.body.classList.toggle('bb-past-atc', past);
    }
    window.addEventListener('scroll',check,{passive:true});
    window.addEventListener('resize',check);
    check();
  }
  // Keep the 3 boxes (Save / Volume / Calculator), give each a down-arrow; all CLOSED by default, click to expand.
  var accOpenIdx=-1, accSetup=false, accBtns=[], accPanels=[];
  function accClose(){accPanels.forEach(function(p){p.style.display='none';});accBtns.forEach(function(b){var a=b.querySelector('.bb-tab-arw');if(a)a.style.transform='';});}
  function arrowifyTabs(){
    var bt=document.getElementById('bb-buytabs'); if(!bt) return;
    if(!accSetup){
      var row=bt.children[1]; var btns=row?[].slice.call(row.querySelectorAll('button')):[];
      if(btns.length<2) return;
      accBtns=btns; if(row)row.classList.add('bb-acc-row');
      for(var i=0;i<bt.children.length;i++){var ch=bt.children[i]; if(ch!==row && ch.tagName!=='STYLE') accPanels.push(ch);}
      btns.forEach(function(b,idx){
        b.classList.add('bb-acc-tab');
        for(var k=0;k<b.childNodes.length;k++){var nd=b.childNodes[k];if(nd.nodeType===3&&nd.textContent.trim()){nd.textContent=nd.textContent.replace('Save up to 15%','Save 15%').replace('Volume Orders','Custom').replace('Fence Calculator','Calculator');}}
        var a=document.createElement('span');a.className='bb-tab-arw';a.textContent='▾';a.style.cssText='margin-left:6px;display:inline-block;transition:transform .2s';b.appendChild(a);
        b.addEventListener('click',function(){setTimeout(function(){
          if(accOpenIdx===idx){accClose();accOpenIdx=-1;return;}
          accClose(); if(accPanels[idx])accPanels[idx].style.display=''; var ar=b.querySelector('.bb-tab-arw'); if(ar)ar.style.transform='rotate(180deg)'; accOpenIdx=idx;
        },0);});
      });
      accSetup=true;
    }
    if(accOpenIdx===-1) accClose(); // enforce all-closed default even if the theme auto-opens one
  }
  function customCopy(){
    var bt=document.getElementById('bb-buytabs'); if(!bt) return;
    // Custom dropdown box — richer copy, SAME on mobile (.bb-vol-m) + desktop (.bb-vol-d) so they stay consistent. Owner 2026-07-26 ("more content for custom").
    // Custom box: MOBILE (.bb-vol-m) = concise 2-line; DESKTOP (.bb-vol-d) = full richer copy. Owner 2026-07-26 ("2 lines on mobile, bit too long").
    // ONE Custom write-up, SAME on mobile + desktop. No mesh/cedar/treated. NO leading 🏭 (the theme panel renders its own — a second one here caused a double emoji). Owner 2026-07-26.
    var CUST='<strong>Custom Heights, Widths.</strong> From one-off custom panels to large-volume production runs, straight from our factory. Call or text <strong>1-888-306-BOSS (2677)</strong> for a same-day quote.';
    var vm=bt.querySelector('.bb-vol-m'), vd=bt.querySelector('.bb-vol-d');
    if(vm && vm.getAttribute('data-synced')!=='5'){ vm.innerHTML=CUST; vm.setAttribute('data-synced','5'); }
    if(vd && vd.getAttribute('data-synced')!=='5'){ vd.innerHTML=CUST; vd.setAttribute('data-synced','5'); }
    if(bt.getAttribute('data-cc')) return;
    for(var i=0;i<bt.children.length;i++){
      var p=bt.children[i];
      if(p.textContent && /Bulk orders/i.test(p.textContent)){
        bt.setAttribute('data-cc','1');
        (function walk(node){
          if(node.nodeType===3){ node.textContent=node.textContent.replace('Bulk orders?','Custom sizes & volume.').replace('We do custom-sized production runs for any project','Custom-sized panels + large-volume orders, built to your spec'); }
          else { for(var k=0;k<node.childNodes.length;k++) walk(node.childNodes[k]); }
        })(p);
        break;
      }
    }
  }
  function build(){nukeNativeTop();/* sticky cart pill removed (owner 2026-11-03). buildBar() is left defined on purpose: the DOCK (#bb-fab) is a separate thing and must keep working. */buildFab();hideTidio();setupScrollGate();arrowifyTabs();customCopy();setTimeout(function(){nukeNativeTop();setupScrollGate();arrowifyTabs();customCopy();},1500);setTimeout(function(){setupScrollGate();arrowifyTabs();customCopy();if(!scrollGateDone){document.body.classList.add('bb-past-atc');document.body.classList.remove('bb-cart-off');}},3500);}
  if(document.readyState!=='loading')build();else document.addEventListener('DOMContentLoaded',build);
})();


/* ===== CART-OPEN GUARD (owner 2026-10-07) =========================================
   The sticky ATC pill (#bb-matc) and the FAB stack (#bb-fab) were rendering ON TOP of
   the open slide cart, so the cart sat behind an "Add to Cart" bar for a product the
   shopper was already past.

   This file decides visibility from SCROLL POSITION ONLY and never knew the drawer
   existed. Rather than thread cart state through the existing show/hide branches, a
   stylesheet rule hides all three while the drawer is on screen; because the script
   sets display inline, the rule carries !important, and it simply stops matching when
   the drawer closes, handing control straight back to the scroll logic.

   ⛔ Openness is MEASURED (geometry + computed style), not read off a class name — the
      drawer's open-class is theme internals and would silently rot.                */
(function () {
  var SEL = '#sidebar-cart, .Cart-Drawer, [data-cart-drawer]';
  function visible(el) {
    if (!el) return false;
    var r = el.getBoundingClientRect();
    if (r.width < 2 || r.height < 2) return false;
    if (r.right < 1 || r.bottom < 1) return false;            /* parked off-canvas */
    var cs = window.getComputedStyle(el);
    return cs.display !== 'none' && cs.visibility !== 'hidden' && cs.opacity !== '0';
  }
  function cartOpen() {
    var n = document.querySelectorAll(SEL);
    for (var i = 0; i < n.length; i++) if (visible(n[i])) return true;
    return false;
  }
  try {
    var st = document.createElement('style');
    st.id = 'bb-matc-cartguard';
    st.textContent = 'body.bb-cart-open #bb-matc,' +
                     'body.bb-cart-open #bb-fab,' +
                     'body.bb-cart-open #bb-fab-pop{display:none !important;}';
    (document.head || document.documentElement).appendChild(st);
  } catch (e) { /* no stylesheet, nothing else to do */ }

  var last = null;
  function sync() {
    var o = cartOpen();
    if (o === last) return;                                    /* only touch the DOM on a change */
    last = o;
    document.body.classList.toggle('bb-cart-open', o);
  }
  sync();
  /* body class flips drive most drawer opens; the poll covers transitions and app-driven opens */
  try {
    new MutationObserver(sync).observe(document.body, { attributes: true, attributeFilter: ['class', 'style'] });
  } catch (e) { /* observer unavailable */ }
  ['click', 'keyup', 'cart:open', 'cart:close', 'cart:refresh'].forEach(function (ev) {
    document.addEventListener(ev, function () { setTimeout(sync, 60); }, true);
  });
  setInterval(sync, 300);
})();
